



























































import { ResourceUtils } from '@/util/resourceUtils';
import { Component, Vue } from 'vue-property-decorator';
@Component({
    props: {
        accessKey: Object,
    },
})
export default class AccessKeyModal extends Vue {
    private show = true;
    private disableButton = false;

    private copyText() {
      const copyText = document.getElementById('myInput') as HTMLInputElement;
      if (copyText) {
        copyText.select();
        document.execCommand('Copy');
      }
    }
    private downloadAccessKeyCSVFile() {
      const accessKeyData = [ {
        accessKey: this.$props.accessKey.accessKeyID,
        secretAccessKey: this.$props.accessKey.secretAccessKey,
      }];
      const headers = ['Access Key Id, Secret Access Key'];
      const accessKeyRows = accessKeyData.map((data) =>
          `${data.accessKey}, ${data.secretAccessKey}`,
      );
      const accessKeyCSVFile = headers.concat(accessKeyRows).join('\n');
      ResourceUtils.downloadFileIntoDevice(accessKeyCSVFile, 'accessKey.csv');
      this.disableButton = true;
    }
    private close() {
        this.$emit('close');
    }
}
